const { Entities } = require('./entities');
const Enum = require('./enum');

/**
 * Defines resource type
 *
 * @enum
 * @readonly
 */
exports.ResourceTypes = Object.create(Enum, {
  HOUSE: { value: Entities.HOUSE, enumerable: true },
  LOCK: { value: Entities.LOCK, enumerable: true },
  DOORBELL: { value: Entities.DOORBELL, enumerable: true },
  ALARM: { value: Entities.ALARM_HUB, enumerable: true },
  AREA: { value: 'area', enumerable: true },
  WA_SYSTEM: { value: 'wa_system', enumerable: true },
});
